<template>
    <div
        class="content-blocks"
        :class="{
            'ma-0 pa-0': !isMobile
        }"
    >
        <v-row
            class="fill-width fill-height flex-grow-0 flex-shrink-1"
            no-gutters
        >
            <ContentBlockCmp
                v-for="(block, index) in blocks"
                :key="`content-block-${block.id}-${index}`"
                :block="block"
                :theme="themeName"
                :breakpoint="breakpoint"
                :breakpoint-name="breakpointName"
                :is-constrained-width="block.constrainedWidth"
                :is-hyperlink-block="!!block.hyperlinkBlock"
                :is-mobile="isMobile"
            ></ContentBlockCmp>
        </v-row>
    </div>
</template>

<script lang="ts" setup>
    import type { ContentBlock } from '~/types';
    import { default as ContentBlockCmp } from '~/components/content/ContentBlock/ContentBlock.vue';
    import { useCurrentTheme, useIsMobile } from '~/composables';
    import { useDisplay } from 'vuetify';

    withDefaults(
        defineProps<{
            blocks: Nilish<ContentBlock[]>;
        }>(),
        {
            blocks: () => []
        }
    );

    const { name: breakpointName } = useDisplay();
    const { themeName } = useCurrentTheme();
    const isMobileObj = useIsMobile();
    const { isMobile } = isMobileObj;

    const breakpoint = computed<string>(() => (isMobile.value ? 'mobile' : 'desktop'));
</script>

<style lang="scss" scoped></style>
